import { RefreshCw } from 'lucide-react'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Typography } from '@/components/ui/typography'
import { PortalEquityTransactionsRegister } from '@/components/custom/portal/portal-equity-transactions-register'
import { PortalFinancialStatCards } from '@/components/custom/portal/portal-financial-stat-cards'
import { SectionHeader } from '@/components/custom/companies/section-header'
import { usePortalCompany } from '@/hooks/use-portal'
import { formatDate } from '@/lib/format'
import type { PortalTabValue } from '@/components/custom/portal/portal-tabs'

export function PortalOverviewTab({
  onNavigateToFinancials,
}: {
  onNavigateToFinancials: (
    tab: PortalTabValue,
    trailingPeriod?: string,
    view?: string
  ) => void
}) {
  const { data: company } = usePortalCompany()
  const ltmPeriodEndDate = company?.ltmPeriodEndDate ?? null
  const financialsUpdatedAt = company?.financialsUpdatedAt ?? null

  return (
    <div className="space-y-4">
      <section className="space-y-3">
        <SectionHeader
          title="Financials"
          afterTitle={
            <Tooltip>
              <TooltipTrigger asChild>
                <Typography
                  as="span"
                  variant="body-sm"
                  className="cursor-default text-primary/70"
                  tabIndex={0}
                >
                  · LTM
                </Typography>
              </TooltipTrigger>
              <TooltipContent>
                Last Twelve Months, measured at each quarter-end
              </TooltipContent>
            </Tooltip>
          }
        />
        {ltmPeriodEndDate || financialsUpdatedAt ? (
          <div className="flex flex-wrap gap-2">
            <div className="flex h-[22px] items-center gap-1 rounded-sm bg-primary/5 px-2 py-0.5 text-primary/70">
              <RefreshCw className="h-3 w-3" />
              <Typography
                variant="body-sm"
                as="span"
                className="text-primary/70"
              >
                As of: {ltmPeriodEndDate ? formatDate(ltmPeriodEndDate) : '—'}
              </Typography>
            </div>
            <div className="flex h-[22px] items-center rounded-sm bg-primary/5 px-2 py-0.5 text-primary/70">
              <Typography
                variant="body-sm"
                as="span"
                className="text-primary/70"
              >
                Last synced:{' '}
                {financialsUpdatedAt ? formatDate(financialsUpdatedAt) : '—'}
              </Typography>
            </div>
          </div>
        ) : null}
        <PortalFinancialStatCards
          onNavigateToFinancials={onNavigateToFinancials}
        />
      </section>

      <section className="space-y-3">
        <SectionHeader title="Equity Transactions" />
        <PortalEquityTransactionsRegister />
      </section>
    </div>
  )
}
